<template>
  <div class="home">
    <Header />
    <main>
      <div class="introduce">
        <div class="left">
          <div class="title">{{ $t('main.title') }}</div>
          <div class="desc-wrap">
            <span class="intro">{{ $t('main.intro') }}</span>
            <a :href="tutorialUrl" target="_blank" class="tutorial">{{
              $t('main.tutorial')
            }}</a>
          </div>
        </div>
        <div class="main-img">
          <img src="../assets/main-img.png" alt="" />
        </div>
      </div>
      <div class="version-container">
        <div class="version-header">
          <div class="drop-down-box-list">
            <div class="drop-down-box-item-system">
              <DropDownBoxItem
                :data="systemList"
                :platform="platform"
                @getPlatform="getPlatform"
              />
            </div>
            <div class="drop-down-box-item-version">
              <DropDownBoxItem
                :data="optionVersionList"
                :platform="platform"
                @getVersion="getVersion"
              />
            </div>
            <div class="drop-down-box-item-channel">
              <DropDownBoxItem
                :data="channelList"
                :platform="platform"
                @getChannel="getChannel"
              />
            </div>
          </div>
        </div>
        <div class="version-list-wrap">
          <VersionList
            :platform="platform"
            :list="versionList"
            @getVersionLog="getVersionLog"
          />
        </div>
      </div>
    </main>
    <Footer />
    <ModalLog :logParam="logParam" v-if="isModalLog" @closeModal="closeModal" />
  </div>
</template>

<script>
import Header from '../components/common/Header.vue';
import Footer from '../components/common/Footer.vue';
import VersionList from '../components/common/VersionList.vue';
import ModalLog from '../components/common/ModalLog.vue';
import DropDownBoxItem from '../components/common/DropDownBoxItem.vue';
import _ from 'lodash';
import { TP_SERVER_DOMAIN, compareVersion } from "../utils";
export default {
  name: 'Home',
  components: { Header, Footer, VersionList, ModalLog, DropDownBoxItem },
  data() {
    return {
      versionList: [],
      androidList: [],
      iosList: [],
      platform: 1, // 平台 0 iOS, 1 Android
      version: '',
      channel: '',
      logParam: {},
      isModalLog: false,
    };
  },
  computed: {
    tutorialUrl() {
      if (window.location.hostname === 'verify.tokenpocket.pro') {
        if (this.$i18n.locale === 'zh') {
          return 'https://help.tokenpocket.pro/cn/security-knowledge/protective-measures/verification';
        } else {
          return 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/verify';
        }
      } else {
        if (this.$i18n.locale === 'zh') {
          return 'https://help.tpwallet.io/cn/security-knowledge/protective-measures/verification';
        } else {
          return 'https://help.tpwallet.io/en/security-knowledge/security-measure/verify';
        }
      }
    },
    downVersionList() {
      let arr = [];
      if (this.platform === 1) {
        arr = this.androidList.map((item) => ({
          label: item.version,
          version: item.version,
        }));
      } else {
        arr = this.iosList.map((item) => ({
          label: item.version,
          version: item.version,
        }));
      }
      arr = _.uniqBy(arr, 'version');
      return arr;
    },
    downChannelList() {
      let arr = [];
      if (this.platform === 1) {
        arr = this.androidList.map((item) => {
          let label = item.channel_desc_en;
          if (this.$i18n.locale === 'zh') {
            label = item.channel_desc;
          }
          return {
            label: label,
            channel: label,
            icon_url: item.icon_url,
          };
        });
      } else {
        arr = this.iosList.map((item) => {
          let label = item.channel_desc_en;
          if (this.$i18n.locale === 'zh') {
            label = item.channel_desc;
          }
          return {
            label: label,
            channel: label,
            icon_url: item.icon_url,
          };
        });
      }
      arr = _.uniqBy(arr, 'channel');
      return arr;
    },
    systemList() {
      return {
        title: this.$t('main.system'),
        system: true,
        list: [
          { label: this.$t('main.android'), platform: 1 },
          { label: this.$t('main.ios'), platform: 0 },
        ],
      };
    },
    optionVersionList() {
      return {
        title: this.$t('main.version'),
        version: true,
        list: [
          { label: this.$t('main.allVersion'), version: '' },
          ...this.downVersionList,
        ],
      };
    },
    channelList() {
      return {
        title: this.$t('main.appChannel'),
        channel: true,
        list: [
          { label: this.$t('main.allChannel'), channel: '' },
          ...this.downChannelList,
        ],
      };
    },
  },
  created() {
    const query = this.$route.query
    if (query) {
      console.log('query', query);
      if (query.os === 'iOS') {
        this.platform = 0
      } else {
        this.platform = 1
      }
    }
    this.getVersionList(this.platform);
  },
  methods: {
    /** 获取版本列表 */
    async getVersionList(platform) {
      this.versionList = []
      try {
        const response = await fetch(
          `${TP_SERVER_DOMAIN}/v1/version/channel_version_list?platform=${platform}`
        );
        const res = await response.json();
        // console.log('versionList', res);
        if (res.result === 0 && res.data) {
          if (Array.isArray(res.data)) {
            res.data.forEach(item => {
              item.developer = 'TP Global Ltd'
            });
            if (platform === 1) {
              this.androidList = res.data;
            } else {
              // aps渠道的包不再显示
              let list = res.data.filter((item) => item.channel !== 'aps');
              list.forEach(fItem => {
                // console.log('version', compareVersion('2.3.4', fItem.version));
                const flag = compareVersion('2.3.4', fItem.version)
                if (flag !== 1 && fItem.channel === 'tpg') {
                  fItem.channel_desc = fItem.channel_desc.replace('TP Wallet', 'TokenPocket')
                  fItem.channel_desc_en = fItem.channel_desc_en.replace('TP Wallet', 'TokenPocket')
                }
                const flag2 = compareVersion('2.7.5', fItem.version)
                if (flag2 !== 1 && fItem.channel === 'tpg') {
                  fItem.channel = 'com.global.wallet.ios';
                }
              })
              this.iosList = list;
            }
            this.conformParam();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.isModalLog = false;
    },
    /** 获取版本更新日志 */
    async getVersionLog(obj) {
      this.logParam = obj;
      this.isModalLog = true;
    },
    getPlatform(platform) {
      // 切换平台重置筛选数据
      if (this.platform !== platform) {
        this.version = '';
        this.channel = '';
        this.getVersionList(platform);
      }
      this.platform = platform;
    },
    getVersion(version) {
      this.version = version;
      this.conformParam();
    },
    getChannel(channel) {
      this.channel = channel;
      this.conformParam();
    },
    conformParam() {
      let list = this.iosList;
      if (this.platform === 1) {
        list = this.androidList;
      }
      this.versionList = this.filterVersionList(
        list,
        this.version,
        this.channel
      );
    },

    /** 筛选版本列表 */
    filterVersionList(list, version, channel) {
      // 全部
      if (!version && !channel) {
        return list;
      }
      // 有版本没有渠道
      else if (version && !channel) {
        list = list.filter((v) => v.version === version);
      }
      // 有版本有渠道
      else if (version && channel) {
        if (this.$i18n.locale === 'zh') {
          list = list.filter(
            (v) => v.version === version && v.channel_desc === channel
          );
        } else {
          list = list.filter(
            (v) => v.version === version && v.channel_desc_en === channel
          );
        }
      }
      // 没有版本有渠道
      else if (!version && channel) {
        if (this.$i18n.locale === 'zh') {
          list = list.filter((v) => v.channel_desc === channel);
        } else {
          list = list.filter((v) => v.channel_desc_en === channel);
        }
      }
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  main {
    margin: 60px 0 40px;
    .introduce {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .left {
        .title {
          font-size: 40px;
          font-weight: 700;
          color: #1a202c;
          letter-spacing: 0.04px;
        }
        .desc-wrap {
          margin-top: 20px;
          line-height: 30px;
          .intro {
            font-size: 19px;
            color: #6f7174;
          }
          .tutorial {
            font-size: 20px;
            color: #2980fe;
            white-space: nowrap;
          }
        }
      }
      .main-img {
        margin-left: 103px;
        img {
          width: 519px;
          height: 470px;
        }
      }
    }
    .version-container {
      max-width: 1200px;
      margin: 0 auto;
      .version-header {
        .drop-down-box-list {
          display: flex;
          align-items: center;
          .drop-down-box-item-version {
            margin-left: 20px;
          }
          .drop-down-box-item-channel {
            margin-left: 20px;
          }
        }
      }
      .version-list-wrap {
        width: 100%;
        overflow: auto;
        margin-top: 24px;
        border-radius: 16px;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .home {
    main {
      padding: 0 28px;
      margin: 120px 0;
      .introduce {
        flex-direction: column;
        .left {
          .title {
            text-align: center;
            font-size: 28px;
          }
          .desc-wrap {
            text-align: center;
            line-height: 22px;
            .intro {
              font-size: 14px;
              color: #9ea0a5;
            }
            .tutorial {
              font-size: 14px;
            }
          }
        }
        .main-img {
          margin-left: 0;
          margin-top: 30px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
      .version-container {
        margin-top: 50px;
        width: 100%;
        max-width: none;
        .version-header {
          .drop-down-box-list {
            flex-wrap: wrap;
            justify-content: space-between;
            .drop-down-box-item-system {
              width: 40%;
            }
            .drop-down-box-item-version {
              width: 50%;
            }
            .drop-down-box-item-channel {
              margin-left: 0;
              margin-top: 20px;
              width: 100%;
            }
          }
        }
        .version-list-wrap {
          border-radius: 10px;
          overflow: auto;
        }
      }
    }
  }
}
</style>
